import jQuery from 'jquery'

const _window: any = window || {}

_window.$ = jQuery
_window.jQuery = jQuery
